import { I18nt } from 'utils';
import Container from 'components/Container';
import styles from './ConsultaMedicamentos.module.less';
import BannerWithImage from 'components/BannerWithImage';
import loaderImg from 'assets/images/cruces-loanding.png';
import { useConsultaMedicamentos } from '../ConsultaMedicamentosContext';
import DownloadPage from 'components/DownloadPage';

const Loading = () => (
	<Container className={styles.loadingContainer}>
		<h5 className={styles.titleText}>{I18nt('estamos_validando_la')}</h5>
		<div className={styles.loaderContainer}>
			<img src={loaderImg} alt='loader' />
		</div>
	</Container>
);

const NotAvailable = () => {
	const { resetState, infoReceta, dispatch } = useConsultaMedicamentos();

	const pdfPath =
		infoReceta?.basico_express === 'E'
			? '/politica_de_reembolso_express.pdf'
			: '/politica_de_reembolso.pdf';

	return (
		<DownloadPage
			goBackAction={resetState}
			subTitle='en_este_momento'
			text='consulta_aqui_nuestras'
			href={pdfPath}
			download='politica_de_reembolso'
			goBackText='regresar_al_formulario'
			downloadBtn='politica_de_reembolso'
			btnAction={() => dispatch({ type: 'setShowInfoReceta', payload: false })}
			title={I18nt('gracias_por_tu_respuesta', {
				name: infoReceta?.nombrePaciente,
			})}
		/>
	);
};

export default function LoadingPage() {
	const { notAvailable } = useConsultaMedicamentos();

	if (notAvailable) {
		return <NotAvailable />;
	}

	return (
		<BannerWithImage className={styles.loadingPageContainer}>
			<Loading />
		</BannerWithImage>
	);
}
